import TypographyElement from "@/views/elements/typography/TypographyElement"
import { useTheme } from "@mui/material"
import { useTranslation } from "react-i18next"

type Props = {
    rank: string
    sx?: any
}

export default function RenderRank({ rank, sx }: Props) {
    const theme = useTheme()
    const { t } = useTranslation()

    const RANK: any = {
        COPPER: t("copytrade.rank.COPPER"),
        SILVER: t("copytrade.rank.SILVER"),
        GOLD: t("copytrade.rank.GOLD"),
        Plamium: t("copytrade.rank.PLATINUM"),
        PLATINUM: t("copytrade.rank.PLATINUM"),
        DIAMOND: t("copytrade.rank.DIAMOND"),
        F: t("copytrade.common.eFollower"),
        M: t("copytrade.common.eMaster")
    }

    const cvRank = RANK[rank] ?? rank
    const Csx = {
        backgroundColor: theme.palette.background.badge,
        color: theme.palette.primary.main, alignContent: "center",
        px: 1, borderRadius: 1,
        ...sx
    }
    return (
        <TypographyElement ColorElement="brand" FontSizeElement='12px' FontWeightElement={400}
            sx={Csx}>
            {cvRank}
        </TypographyElement>
    )
}